// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.btn-link {
  align-items: normal;
  background-color: rgba(0, 0, 0, 0);
  border-color: rgb(0, 0, 238);
  border-style: none;
  box-sizing: content-box;
  color: rgb(0, 0, 238);
  cursor: pointer;
  display: inline;
  font: inherit;
  height: auto;
  padding: 0;
  perspective-origin: 0 0;
  text-align: start;
  transform-origin: 0 0;
  width: auto;
  -moz-appearance: none;
  -webkit-logical-height: 1em; /* Chrome ignores auto, so we have to use this hack to set the correct height  */
  -webkit-logical-width: auto; /* Chrome ignores auto, but here for completeness */
}

/* Mozilla uses a pseudo-element to show focus on buttons, */
/* but anchors are highlighted via the focus pseudo-class. */

@supports (-moz-appearance: none) {
  /* Mozilla-only */
  button.btn-link::-moz-focus-inner {
    /* reset any predefined properties */
    border: none;
    padding: 0;
  }
  button.btn-link:focus {
    /* add outline to focus pseudo-class */
    outline-style: dotted;
    outline-width: 1px;
  }
}

button.btn-link:before {
  content: "";
  display: inline-block;
  border-top: 1px solid #005eb8;
  border-right: 1px solid #005eb8;
  vertical-align: middle;
  width: 4px;
  height: 4px;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  transition:
    transform 0.2s,
    -webkit-transform 0.2s;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin: -1px 8px 0 -1em;
}
`, "",{"version":3,"sources":["webpack://./src/parametric-search/components/app/Footer/FooterInfo.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;EACb,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,2BAA2B,EAAE,gFAAgF;EAC7G,2BAA2B,EAAE,mDAAmD;AAClF;;AAEA,4DAA4D;AAC5D,4DAA4D;;AAE5D;EACE,iBAAiB;EACjB;IACE,oCAAoC;IACpC,YAAY;IACZ,UAAU;EACZ;EACA;IACE,sCAAsC;IACtC,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;EAC1B;;0BAEwB;EACxB,gCAAgC;EAChC,wBAAwB;EACxB,uBAAuB;AACzB","sourcesContent":["button.btn-link {\n  align-items: normal;\n  background-color: rgba(0, 0, 0, 0);\n  border-color: rgb(0, 0, 238);\n  border-style: none;\n  box-sizing: content-box;\n  color: rgb(0, 0, 238);\n  cursor: pointer;\n  display: inline;\n  font: inherit;\n  height: auto;\n  padding: 0;\n  perspective-origin: 0 0;\n  text-align: start;\n  transform-origin: 0 0;\n  width: auto;\n  -moz-appearance: none;\n  -webkit-logical-height: 1em; /* Chrome ignores auto, so we have to use this hack to set the correct height  */\n  -webkit-logical-width: auto; /* Chrome ignores auto, but here for completeness */\n}\n\n/* Mozilla uses a pseudo-element to show focus on buttons, */\n/* but anchors are highlighted via the focus pseudo-class. */\n\n@supports (-moz-appearance: none) {\n  /* Mozilla-only */\n  button.btn-link::-moz-focus-inner {\n    /* reset any predefined properties */\n    border: none;\n    padding: 0;\n  }\n  button.btn-link:focus {\n    /* add outline to focus pseudo-class */\n    outline-style: dotted;\n    outline-width: 1px;\n  }\n}\n\nbutton.btn-link:before {\n  content: \"\";\n  display: inline-block;\n  border-top: 1px solid #005eb8;\n  border-right: 1px solid #005eb8;\n  vertical-align: middle;\n  width: 4px;\n  height: 4px;\n  -webkit-transition: -webkit-transform 0.2s;\n  transition: -webkit-transform 0.2s;\n  transition: transform 0.2s;\n  transition:\n    transform 0.2s,\n    -webkit-transform 0.2s;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  margin: -1px 8px 0 -1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
